module.exports = __webpack_public_path__ + "img/dots.001bff8d.svg";